<div cwpComponent></div>
<div cwpComponent></div>
<div cwpComponent></div>
<div cwpComponent></div>
<div class="dz-grid padding-bottom-80" *ngIf="isBlkModelsAvailable$ | async">
	<div class="dz-row">
		<mb-explore-card class="padding-0" (onExploreCardChange)="selectedExploreCard = $event"></mb-explore-card>
	</div>
	<ng-container *ngIf="selectedExploreCard">
		<div class="dz-row">
			<div class="dz-col-lg-4 padding-0">
				<mb-home-page-left-nav [selectedExploreCard]="selectedExploreCard" (optionSelected)="setSelectedGreyCardsDetail($event)"></mb-home-page-left-nav>
			</div>
			<div class="dz-col-lg-20">
				<ng-container *ngIf="families.length; else noData">
					<mb-portfolio-selection-cards-container
						*componentId="{ componentId: 'me.families', ids: familyIds$ }; let res"
						[data]="res"
						[filter]="modelFilter$ | async"
						[selectedModelsToCompare]="selectedModels"
						[selectedExploreCard]="selectedExploreCard"
						[selectedLeftNav]="selectedLeftNav"
						(selectedModels)="setSelectedModelPortfolios($event)"
					></mb-portfolio-selection-cards-container>
				</ng-container>
			</div>
		</div>
	</ng-container>
	<div class="margin-top-16">
		<ac-disclosure *ngIf="!isAuthenticated" dcrKey="ME_HOME_DISCLOSURE_PUBLIC"></ac-disclosure>
		<ac-disclosure *ngIf="isAuthenticated" dcrKey="ME_HOME_DISCLOSURE"></ac-disclosure>
	</div>
</div>
<ng-template #noData>
	<div dcrHTMLKey="HOME_PAGE_NO_FAMILIES_DATA_AVAILABLE" class="padding-24">Families not available</div>
</ng-template>
<me-mini-compare-bar
	*ngIf="selectedModels?.length"
	[selectedModelsToCompare]="selectedModels"
	(openMiniCompareDialog)="onOpenMiniCompareDialog()"
	(removeSelectedModel)="onRemoveSelectedModelsData($event)"
></me-mini-compare-bar>
<div cwpComponent></div>
<div cwpComponent></div>
<div cwpComponent></div>
<div cwpComponent></div>
